import type { AdminApi } from './client.ts';

export const environmentsQuery = (api: AdminApi) => ({
  queryKey: ['environments'],
  queryFn: () => api.listEnvironments(),
});

export const meQuery = (api: AdminApi) => ({ queryKey: ['me'], queryFn: () => api.me() });
